<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2 >Edit User</h2> 
            </div>
        </div> 
        <div class="row mt-4">
            <form novalidate="novalidate" @submit.prevent="submit" class="col col-md-12 border-top border-bottom py-4"> 
                <div class="row">
                    <div class="col-md-6">
                        <h4>User Details</h4>

                        <div class="form-group row">
                            <label for="first_name" class="col-md-4 col-form-label text-md-right">First Name</label>
                            <div class="col-md-8">
                                <input id="first_name" type="text" class="form-control " :class="{'is-invalid': firstNameHasError}" name="first_name" v-model="first_name" required="required" autocomplete="first_name" autofocus>
                                <form-error name="first_name" :errors="errors"></form-error>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="last_name" class="col-md-4 col-form-label text-md-right">Surname</label>
                            <div class="col-md-8">
                                <input id="last_name" type="text" class="form-control " :class="{'is-invalid': lastNameHasError}" name="last_name" v-model="last_name" required="required" autocomplete="last_name">
                                <form-error name="last_name" :errors="errors"></form-error>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="collar" class="col-md-4 col-form-label text-md-right">Collar</label>
                            <div class="col-md-8">
                                <input id="collar" type="text" class="form-control " :class="{'is-invalid':collarHasError}" name="collar" required="required" autocomplete="collar" v-model="collar">
                                <form-error name="collar" :errors="errors"></form-error>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="telephone-extension" class="col-md-4 col-form-label text-md-right">Tel Ext.</label>
                            <div class="col-md-8">
                                <input id="telephone-extension" type="text" class="form-control " :class="{'is-invalid':telephoneHasError}" name="telephone_extension" required autocomplete="telephone" v-model="telephone_extension">
                                <form-error name="telephone_extension" :errors="errors"></form-error>
                            </div>
                        </div>
                
                    </div>

                    <div class="col-md-6">
                        <h4>Police Details</h4>

                        <div class="form-group row">
                            <label for="rank" class="col-md-4 col-form-label text-md-right">Rank</label>

                            <div class="col-md-8">
                                <select class="custom-select " :class="{'is-invalid': rankHasError}" id="rank" name="rank" required="required" v-model="rank_id">
                                    <option value="">--- Please Select ---</option>
                                    <option v-for="rank in ranks" :key="rank.id" :value="rank.id">
                                        {{ rank.name }}
                                    </option>
                                </select>
                                <form-error name="rank_id" :errors="errors"></form-error>
                            </div>
                        </div>

                        <div class="form-group row">
                            <label for="force" class="col-md-4 col-form-label text-md-right">Force</label>

                            <div class="col-md-8">
                                <select class="custom-select " :class="{'is-invalid': forceHasError}" id="force" disabled name="force" required="required" v-model="force_id">
                                    <option value="">--- Please Select ---</option>
                                    <option v-for="force in forces" :key="force.id" :value="force.id">
                                        {{ force.name }}
                                    </option>
                                </select>
                                <form-error name="force" :errors="errors"></form-error>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="default_lpa" class="col-md-4 col-form-label text-md-right">Default LPA</label>

                            <div class="col-md-8">
                                <select class="custom-select" :class="{'is-invalid': lpaHasError}" id="default_lpa" name="default_lpa" :disabled="lpas.length === 0" required="required" v-model="default_lpa_id">
                                    <option value="">--- Please Select ---</option>
                                    <option v-for="lpa in lpas" :key="lpa.id" :value="lpa.id">
                                        {{ lpa.name }}
                                    </option>
                                </select>
                                
                                <form-error name="default_lpa_id" :errors="errors"></form-error>
                            </div>
                        </div>

                        <div class="form-group row" v-if="!isProfile">
                            <label for="role" class="col-md-4 col-form-label text-md-right">Role</label>

                            <div class="col-md-8">
                                <select class="custom-select" :class="{'is-invalid': roleHasError}" id="role" name="role" :disabled="roles.length === 0" required="required" v-model="role">
                                    <option value="">--- Please Select ---</option>
                                    <option v-for="role in roles" :key="role.id" :value="role.id">
                                        {{ role.name }}
                                    </option>
                                </select>
                                
                                <form-error name="role_id" :errors="errors"></form-error>
                            </div>
                        </div>

                        <div class="form-group row">

                            <div class="offset-lg-4 col-lg-8 ">
                                <router-link :to="{name:'password.change'}" class="btn btn-outline-primary" v-if="isProfile">Change Password</router-link>
                                <button type="button" class="ml-2 btn btn-warning" @click.prevent="authorise" 
                                    v-if="awaiting_authorisation"
                                    :disabled="authorising" >
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="authorising">
                                    </span>Authorize</button>
                            </div>
                        </div>
                
                    </div>
                </div>

                <div class="form-group row">
                    <div class="col-sm-10 offset-sm-2" >
                        <button type="submit" class="btn btn-primary" v-if="! this.loading">Save</button>
                        <button type="submit"  class="btn btn-primary" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>
                </div> 
                <button class="btn btn-link" @click.prevent="back">Back to List</button>
            </form>
        </div>
    </div>
</template>

<script>
import FormError from "../../Util/FormError"
import UsersService from "../../../services/UsersService"
import CurrentUser from "../../../mixins/CurrentUser"

export default {
    data: function () {
        return {
            loading: false,
            first_name: '',
            last_name: '',
            email: '',
            password: '',
            password_confirmation: '',
            force_id: '',
            default_lpa_id: '',
            rank_id: '',
            collar: '',
            telephone_extension: '',
            role: '',
            awaiting_authorisation: false,
            authorising: false,
            errors: {},
        }
    },

    mixins: [CurrentUser],

    props: {
        id: {
            default: null,
        },
    },
    
    components: {FormError},

    mounted(){
        if (!this.isProfile) {
            this.$store.dispatch('roles/load');
            this.$store.dispatch('lpas/load');
        }
        if (this.id) {
            this.load();
        }
    },

    watch: {
        id: function () {
            this.load();  
        },
    },

    methods: {
        submit: function () {
            if (this.id === null) {
                UsersService.store(this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            } else {
                UsersService.update(this.id, this.formData())
                    .then( ({data}) => this.success(data) )
                    .catch( ({response}) => this.failed(response) );
            }
        },

        authorise: function () {
            this.authorising = true;
            UsersService.authorise(this.id)
                .then(() => {
                    this.authorising = false;
                    this.awaiting_authorisation = false;
                    window.flash("User Authorised");
                })
                .catch( () => {
                    this.authorising = false;
                    window.flash("An error occurred.", 'danger');
                });
        },

        back:function () {
            this.$router.go(-1);
        },

        formData: function () {
            return {
                first_name: this.first_name,
                last_name: this.last_name,
                default_lpa_id: this.default_lpa_id,
                rank_id: this.rank_id,
                collar: this.collar,
                telephone_extension: this.telephone_extension,
                role_id: this.role,
            };
        },

        success: function () {
            if (!this.isProfile) {
                this.reset();
                this.$router.go(-1);
            }
            window.flash(this.isProfile ? 'Profile Updated' :'User Updated');
        },

        failed: function (response) {
            this.errors = response.data.errors;
        },

        load: function () {
            this.loading = true;
            UsersService.get(this.id)
                .then( ({data}) => {
                    this.first_name = data.data.first_name,
                    this.last_name = data.data.last_name,
                    this.force_id = data.data.force_id,
                    this.rank_id = data.data.rank_id,
                    this.default_lpa_id = data.data.default_lpa_id,
                    this.collar = data.data.collar,
                    this.telephone_extension = data.data.telephone_extension,
                    this.role = data.data.role_id,
                    this.awaiting_authorisation = data.data.awaiting_authorisation,
                    this.loading = false;
                });
        },

        reset: function () {
            this.first_name = this.last_name = this.email = this.password = this.password_confirmation = '';
            this.role = this.force_id = this.default_lpa_id = this.rank_id = this.collar = this.telephone_extension = '';
            this.loading = this.awaiting_authorisation = false;
            this.errors = {};
        },

        hasError: function (key) {
            return (this.errors[key]);
        }
    },

    computed: {
        firstNameHasError: function() {  return this.hasError('first_name') },
        lastNameHasError: function() {  return this.hasError('last_name') },
        emailHasError: function() {  return this.hasError('email') },
        passwordHasError: function() {  return this.hasError('password') },
        forceHasError: function() {  return this.hasError('force_id') },
        rankHasError: function() {  return this.hasError('rank_id') },
        lpaHasError: function() {  return this.hasError('default_lpa_id') },
        collarHasError: function() {  return this.hasError('collar') },
        telephoneHasError: function() {  return this.hasError('telephone_extension') },
        roleHasError: function() {  return this.hasError('role_id') },

        forces: function () {
            return this.$store.state.forces.data;
        },
        
        roles: function () {
            return this.$store.state.roles.data;  
        },

        ranks: function () {
            return this.$store.state.ranks.data;  
        },

        lpas: function () {            
            if (this.force === undefined) {
                return [];
            }
            
            return this.force.lpas;
        },

        force: function () {
            return this.forces.find(force => force.id == this.force_id);
        },

        isProfile: function () {
            return this.currentUser.id == this.id;
        },
    }
}
</script>